export const debtorsEn = {
  // BEGIN Michael
  DEBTOR: 'Debtor',
  DEBTORS: 'Debtors',
  ACTIVE: 'Active',
  REQUESTED: 'Requested',

  DEBTOR_INFORMATION: 'Debtor Information',
  DEBTOR_NAME: 'Debtor name',
  ACTIVE_DEBTORS: 'Active Debtors',
  REQUEST_CREDIT: 'Request Credit',
  REQUEST_DEBTOR: 'Request Debtor',
  REQUEST_AND_OTHER: 'Request Debtor & Request Another',
  REQUEST_DEBTOR_SUCCESS: 'Debtor Creation Requested Successfully',
  VIEW_DETAILS: 'View Details',
  CREDIT_REQUESTED: 'Credit requested, waiting for approval status',
  CREDIT_REQUEST_DENIED: 'Credit request denied',
  ERROR_REQUESTING_CREDIT: 'Error requesting credit, please try again later',
  CREDIT_REQUESTED_SUCCESSFULLY: 'Credit requested successfully',
  REQUESTED_CREDITS: 'Requested Credits',
  CREDIT_LIMIT: 'Credit Limit',
  CREDIT_LIMIT_APPROVED: 'Credit Limit Approved',
  MC: 'MC',
  MC_NUMBER: 'MC Number',
  DOT_NUMBER: 'Dot Number',
  RELATIONSHIP: 'Relationship',
  REQUESTED_CREDIT_LIMIT: 'Requested Credit Limit',
  REQUESTED_RELATIONSHIP_CREDIT_LIMIT: 'Requested Relationship Credit Limit',
  REQUESTED_AMOUNT: 'Requested Amount',
  // END Michael

  //Debtor Request Form
  BASIC_DETAILS: 'Basic Details',
  COMPANY_NAME: 'Company Name',
  EIN_MUST_BE_9_DIGITS: 'EIN must be 9 digits',
  CONTACT_DETAILS: 'Contact Details',
}

export const debtorsEs: typeof debtorsEn = {
  // BEGIN Michael
  DEBTOR: 'Deudor',
  DEBTORS: 'Deudores',
  ACTIVE: 'Activo',
  REQUESTED: 'Solicitado',

  DEBTOR_INFORMATION: 'Información del Deudor',
  DEBTOR_NAME: 'Nombre deudor',
  ACTIVE_DEBTORS: 'Deudores Activos',
  REQUEST_CREDIT: 'Solicitar Crédito',
  REQUEST_DEBTOR: 'Solicitar Deudor',
  REQUEST_AND_OTHER: 'Solicitar Deudor y solicitar otro',
  REQUEST_DEBTOR_SUCCESS: 'Solicitud de Creación de Deudor Realizada con Éxito',
  VIEW_DETAILS: 'Ver Detalles',
  CREDIT_REQUESTED: 'Crédito solicitado, esperando aprobación',
  CREDIT_REQUEST_DENIED: 'Solicitud de crédito denegada',
  ERROR_REQUESTING_CREDIT:
    'Error solicitando crédito, por favor inténtelo de nuevo más tarde',
  CREDIT_REQUESTED_SUCCESSFULLY: 'Crédito solicitado con éxito',
  REQUESTED_CREDITS: 'Créditos Solicitados',
  CREDIT_LIMIT: 'Límite de Crédito',
  CREDIT_LIMIT_APPROVED: 'Límite de Crédito Aprobado',
  MC: 'MC',
  MC_NUMBER: 'Número MC',
  DOT_NUMBER: 'Número Dot',
  RELATIONSHIP: 'Relación',
  REQUESTED_CREDIT_LIMIT: 'Límite de Crédito Solicitado',
  REQUESTED_AMOUNT: 'Cantidad Solicitada',
  REQUESTED_RELATIONSHIP_CREDIT_LIMIT:
    'Límite de Crédito de Relación Solicitado',
  // END Michael

  //Debtor Request Form
  BASIC_DETAILS: 'Detalles Básicos',
  COMPANY_NAME: 'Nombre de la Compañía',
  EIN_MUST_BE_9_DIGITS: 'EIN debe tener 9 dígitos',
  CONTACT_DETAILS: 'Detalles de Contacto',
}
